import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexXAxis
} from "ng-apexcharts";
import { ResidencesService } from '../../core/services/residences.service';
import { DetailSales, ResedensialOccupancy, DetailSalesPercentage, DetailSalesRevenue, Galleries, ImageItemResidence, ResidencesDetail, ResidencesDetailFacilities, ResidencesDetailSummary, RevenueDetails } from '../../core/models/residences';
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { debounceTime, distinctUntilChanged, Subject, Subscription, takeUntil } from 'rxjs';

export type ChartOptions = {
  series: ApexAxisChartSeries;  // Hapus union type dengan undefined
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-residences-detail',
  templateUrl: './residences-detail.component.html',
  styleUrl: './residences-detail.component.css'
})
export class ResidencesDetailComponent implements OnInit {
  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: ChartOptions;
  public chartSalesPercentage!: ChartOptions;

  images: ImageItemResidence[] = [];
  filteredImages: any[] = [];
  currentFilter: string = 'All Photos';
  currentPage: number = 1;
  itemsPerPage: number = 1;

  expandedStates: boolean[] = [];
  isTotalExpanded: boolean = false;

  // Index untuk setiap section
  totalIndex: number = -1;
  pchIndex: number = -1;
  LHIndex: number = -1;
  ItemResidences: ResidencesDetailFacilities[] = [];
  ItemSummaryDetail: ResidencesDetailSummary[] = [];
  ItemDetail: ResidencesDetail = {} as ResidencesDetail;
  ItemsOccupancy: ResedensialOccupancy = {} as ResedensialOccupancy;

  isLoading = false;
  error = '';
  occupancyError = '';
  maxValue: number = 0;
  maxValuePercentage: number = 0;
  categoryNames: string[] = [];
  currentImageIndex: number = 0;

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = ''
  metaStartDate: string = '';
  metaEndDate: string = '';
  MaxLength: number = 0;
  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  searchTerm: string = '';
  isLoadingRevenue = false;
  isLoadingPercentage = false;

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  private routeSub: Subscription | null = null;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private residencesService: ResidencesService,
  ) {

    this.setupSearchSubscription();

    this.searchForm = this.fb.group({
      searchTerm: ['']
    });

  }

  ngOnInit(): void {
    this.filterImages('All Photos');
    this.loadDatesFromLocalStorage();

    this.loadAllData();
    console.log('isLoading:', this.isLoading);
    console.log('ItemSummaryDetail:', this.ItemSummaryDetail);
    console.log('ItemSummaryDetail length:', this.ItemSummaryDetail?.length);
    console.log('totalRevenueOnly:', this.totalRevenueOnly);
    this.subscribeToRouteParams();

  }

  toggleTotal() {
    console.log('=== TOGGLE TOTAL DIPANGGIL ===');
    console.log('Sebelum:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
    
    this.isTotalExpanded = !this.isTotalExpanded;
    
    console.log('Setelah toggle:', {
        isTotalExpanded: this.isTotalExpanded,
        akan_set_semua_ke: this.isTotalExpanded
    });
    // Expand/collapse semua section
    if (this.pchIndex !== -1) {
        this.expandedStates[this.pchIndex] = this.isTotalExpanded;
        console.log(`PCH (index ${this.pchIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.LHIndex !== -1) {
        this.expandedStates[this.LHIndex] = this.isTotalExpanded;
        console.log(`LH (index ${this.LHIndex}) → ${this.isTotalExpanded}`);
    }
    console.log('Akhir:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
  }

  // Toggle individual section
  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

  private loadDatesFromLocalStorage(): void {
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    this.startDate = startDate || '';
    this.endDate = endDate || '';
  }

  private loadAllData(): void {
    this.loadResidenceDetail();
    // this.loadDetailSales();
    this.loadResidenceDetailSummary();
    this.loadOccupancy();
  }

  private subscribeToRouteParams(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = params['sortDirection'] as 'ASC' | 'DESC' | '' || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.loadResidenceDetailFacilities(this.searchTerm);
      });
  }

  // Method untuk refresh data (ketika filter tanggal berubah)
  public refreshDashboardData(): void {

    // Update localStorage jika diperlukan
    if (this.startDate) localStorage.setItem('startDate', this.startDate);
    if (this.endDate) localStorage.setItem('endDate', this.endDate);

    // Reload data
    this.loadAllData();
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up subscriptions
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  private initChartData(chartData: any[], maxLength: number): void {
    
    // 🔥 FIX 1: Defensive check untuk chartData
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
        console.warn('⚠️ Invalid or empty chartData, using default');
        // Set default chart options dengan data kosong
        this.chartOptions = this.getEmptyChartOptions();
        return;
    }

    // 🔥 FIX 2: Safe mapping dengan fallback values
    const seriesData = chartData.map(item => {
        // Cek berbagai kemungkinan property name
        const value = item?.value ?? item?.pct_occup ?? item?.occupancy ?? 0;
        return typeof value === 'number' ? value : 0;
    });

    const formattedDates = chartData.map(item => {
        // Cek berbagai kemungkinan property name
        return item?.label ?? item?.date ?? item?.period_label ?? item?.name ?? 'Unknown';
    });

    console.log('📊 Processed data:', {
        seriesData,
        formattedDates,
        dataLength: seriesData.length
    });

    // 🔥 FIX 3: Pastikan data tidak kosong
    if (seriesData.length === 0) {
        console.warn('⚠️ No valid data after processing, using default');
        this.chartOptions = this.getEmptyChartOptions();
        return;
    }

    // 🔥 FIX 4: Warna dengan safe array
    const defaultColor = "#B6D1C1";
    const xaxisLabelColors = Array(seriesData.length).fill(defaultColor);
    if (seriesData.length > 0) {
        xaxisLabelColors[seriesData.length - 1] = "#191919";
    }

    // 🔥 FIX 5: Handle maxLength
    const safeMaxLength = maxLength && maxLength > 0 ? maxLength : 100;

    // 🔥 Dynamic height berdasarkan jumlah data
    const baseHeight = 400;
    const heightPerItem = 50;
    const calculatedHeight = Math.max(
        baseHeight, 
        chartData.length * heightPerItem
    );
    
    // Batasi maksimal height jika perlu
    const maxHeight = 800;
    const finalHeight = Math.min(calculatedHeight, maxHeight);

    // 🔥 FIX 6: Chart options dengan safe values
    this.chartOptions = {
        series: [{
            name: "Persentase",
            data: seriesData,
        }],
        chart: {
            height: finalHeight,
            width: '100%',
            type: "bar",
            events: {
                click: function (event: any, chartContext: any, config: any) {
                    const defaultColors = Array(seriesData.length).fill("#B6D1C1");
                    if (config.dataPointIndex !== -1 && config.dataPointIndex < seriesData.length) {
                        defaultColors[config.dataPointIndex] = "#126936";
                    }
                    chartContext.updateOptions({
                        colors: defaultColors
                    }, false, false);
                },
                mouseMove: function (event: any, chartContext: any, config: any) {
                    const defaultColors = Array(seriesData.length).fill("#B6D1C1");
                    if (config.dataPointIndex !== -1 && config.dataPointIndex < seriesData.length) {
                        defaultColors[config.dataPointIndex] = "#126936";
                    }
                    chartContext.updateOptions({
                        colors: defaultColors
                    }, false, false);
                },
            },
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            },
        },
        colors: Array(seriesData.length).fill("#B6D1C1"),
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "60%",
                distributed: true,
                dataLabels: {
                    position: 'end'
                },
                borderRadius: 0
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val: number) {
                return val + "%";
            },
            offsetX: 10,
            style: {
                fontSize: '12px',
                colors: ["#126936"],
                fontWeight: 'bold'
            },
            distributed: true,
        },
        legend: {
            show: false
        },
        grid: {
            show: true,
            position: 'back',
            borderColor: '#E6E6E6',
            xaxis: {
                lines: {
                    show: true,
                },
            },
            yaxis: {
                lines: {
                    show: false,
                }
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 20
            }
        },
        xaxis: {
            categories: formattedDates,
            labels: {
                formatter: function (val: any) {
                    return typeof val === 'number' ? val + "%" : val;
                },
                style: {
                    colors: '#666666',
                    fontSize: '12px',
                    fontWeight: 'normal'
                }
            },
            min: 0,
            max: safeMaxLength,
            tickAmount: 5,
            axisBorder: {
                show: true,
                color: "#E6E6E6"
            },
            axisTicks: {
                show: true,
                color: "#E6E6E6"
            },
            title: {
                text: ""
            },
            crosshairs: {
                show: false
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: xaxisLabelColors,
                    cssClass: 'apexcharts-yaxis-label',
                    fontSize: "12px",
                    fontWeight: 'bold'
                },
                offsetX: -10,
            },
        },
    };

    console.log('✅ Chart options created successfully');
  }

  // 🔥 FIX 7: Method untuk empty chart
  private getEmptyChartOptions(): any {
      return {
          series: [{
              name: "Persentase",
              data: [0]
          }],
          chart: {
              height: 400,
              width: '100%',
              type: "bar",
              toolbar: {
                  show: false
              }
          },
          colors: ["#E6E6E6"],
          plotOptions: {
              bar: {
                  horizontal: true,
                  barHeight: "60%",
                  distributed: true,
              },
          },
          dataLabels: {
              enabled: false
          },
          legend: {
              show: false
          },
          grid: {
              show: true,
          },
          xaxis: {
              categories: ['No Data'],
              labels: {
                  style: {
                      colors: '#999999',
                      fontSize: '12px',
                  }
              },
              min: 0,
              max: 100,
          },
          yaxis: {
              labels: {
                  style: {
                      colors: ['#999999'],
                      fontSize: "12px",
                  }
              },
          },
      };
  }

  // Add these methods to your component
  private setupResizeListener(): void {
    window.addEventListener('resize', this.handleChartResize.bind(this));

    // Clean up listener when component is destroyed
    this.ngOnDestroy = () => {
      window.removeEventListener('resize', this.handleChartResize.bind(this));
    };
  }

  private handleChartResize(): void {
    setTimeout(() => {
      const chartContainer = document.querySelector('.chart-container') as HTMLElement;
      const chartWrapper = document.querySelector('.chart-wrapper') as HTMLElement;

      if (chartContainer && chartWrapper) {
        const windowWidth = window.innerWidth;

        // Determine if scrolling is needed based on screen size and content
        if (windowWidth < 768 && this.chartOptions.series[0].data.length > 5) {
          // For mobile with many data points, enable horizontal scrolling
          chartWrapper.classList.add('enable-scroll');
          chartContainer.style.minWidth = (this.chartOptions.series[0].data.length * 70) + 'px';
        } else if (windowWidth >= 768 && windowWidth < 992 && this.chartOptions.series[0].data.length > 7) {
          // For tablets with many data points
          chartWrapper.classList.add('enable-scroll');
          chartContainer.style.minWidth = (this.chartOptions.series[0].data.length * 60) + 'px';
        } else {
          // For desktop or fewer data points, disable scrolling
          chartWrapper.classList.remove('enable-scroll');
          chartContainer.style.minWidth = '100%';
        }
      }
    }, 100);
  }

  processGalleryData() {
    this.categoryNames = ['All Photos'];

    if (this.ItemDetail && this.ItemDetail.revenue_details) {
      const uniqueCategories = new Set<string>();
      const processedImages: ImageItemResidence[] = [];

      this.ItemDetail.revenue_details.forEach((gallery: RevenueDetails) => {
        if (gallery.name) {
          uniqueCategories.add(gallery.name);

          gallery.galleries.forEach(file => {
            // Store the original path - we'll use the pipe in the template
            processedImages.push({
              src: file.path, // Original path, not transformed
              type: gallery.name,
              alt: file.name
            });
          });
        }
      });

      this.images = processedImages;
      this.filteredImages = [...this.images];
      this.categoryNames = [...this.categoryNames, ...Array.from(uniqueCategories)];

      // console.log(this.categoryNames)
    }
  }

  openGalleryModal(content: any): void {
    const options: any = {
      centered: true,
      windowClass: 'hotel-gallery-modal',
      backdrop: 'static',
      keyboard: false
    };

    // Only apply these classes for medium screens and up
    if (window.innerWidth >= 768) {
      options.size = 'xl';
      options.fullscreen = 'lg';
    }

    this.modalService.open(content, options);
  }

  filterImages(filter: string): void {
    this.currentFilter = filter;
    this.currentPage = 1;

    if (filter === 'All Photos') {
      this.filteredImages = [...this.images];
    } else {
      this.filteredImages = this.images.filter(img => img.type === filter);
    }
  }

  prev(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    } else {
      this.currentPage = Math.ceil(this.filteredImages.length / this.itemsPerPage);
    }
  }

  next(): void {
    if (this.currentPage < Math.ceil(this.filteredImages.length / this.itemsPerPage)) {
      this.currentPage++;
    } else {
      this.currentPage = 1;
    }
  }

  get currentImage(): ImageItemResidence {
    return this.filteredImages.length > 0
      ? this.filteredImages[this.currentImageIndex]
      : { src: '', type: '', alt: '' };
  }

  getTotalPages(): number {
    return Math.ceil(this.filteredImages.length / this.itemsPerPage);
  }

  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadResidenceDetailFacilities(term);
    });
  }

  loadResidenceDetail(): void {
    this.isLoading = true;
    const ResidencesId = this.route.snapshot.paramMap.get('id');
    const parsedId = ResidencesId ? parseInt(ResidencesId) : undefined;

    this.residencesService.getResidencesDetail(
      parsedId,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemDetail = response.data;
        this.processGalleryData();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading residence detail data:', error);
        this.isLoading = false;
        this.ItemDetail = {} as ResidencesDetail;
      }
    });
  }

  get firstFilePath(): string | null {
    return this.ItemDetail?.revenue_details?.[0]?.galleries?.[0]?.path || null;
  }

  loadOccupancy(): void {
      this.isLoadingPercentage = true;
      const ResidencesId = this.route.snapshot.paramMap.get('id');
      const parsedId = ResidencesId ? parseInt(ResidencesId) : undefined;

      console.log('🔍 loadOccupancy called with:', {
          parsedId,
          startDate: this.startDate,
          endDate: this.endDate
      });

      this.residencesService.getResedensialOccupancy(
          parsedId,
          this.startDate,
          this.endDate
      ).subscribe({
          next: (response) => {
              console.log('📦 Full occupancy response:', response);
              console.log('🔑 Response keys:', Object.keys(response || {}));
              
              // Cek response structure
              if (!response) {
                  console.error('❌ Response is null or undefined');
                  this.handleOccupancyError('No response from API');
                  return;
              }

              if (!response.data) {
                  console.error('❌ Response.data is null or undefined');
                  console.log('Response structure:', response);
                  this.handleOccupancyError('No data in response');
                  return;
              }

              console.log('📊 Response.data structure:', {
                  keys: Object.keys(response.data),
                  hasName: 'name' in response.data,
                  hasTotalPct: 'total_pct' in response.data,
                  hasChart: 'chart' in response.data,
                  hasMaxPctValue: 'max_pct_value' in response.data
              });

              // Set data dengan safe check
              try {
                  this.ItemsOccupancy = response.data;
                  this.metaStartDate = response.meta?.start_date || '';
                  this.metaEndDate = response.meta?.end_date || '';
                  
                  // Safe access untuk max_pct_value
                  this.MaxLength = response.data.max_pct_value ?? 0;
                  console.log('📈 MaxLength:', this.MaxLength);
                  
                  // Safe access untuk chart
                  if (response.data.chart && Array.isArray(response.data.chart)) {
                      console.log('📊 Chart data:', response.data.chart);
                      this.initChartData(response.data.chart, this.MaxLength);
                  } else {
                      console.warn('⚠️ Chart data is not available or not an array');
                      this.initChartData([], this.MaxLength);
                  }
                  
                  this.isLoadingPercentage = false;
              } catch (error) {
                  console.error('❌ Error processing occupancy data:', error);
                  this.handleOccupancyError('Error processing data');
              }
          },
          error: (error) => {
              console.error('❌ Error loading resedensial occupancy data:', error);
              console.error('Error details:', {
                  status: error.status,
                  message: error.message,
                  error: error.error
              });
              this.handleOccupancyError('Failed to load occupancy data');
          }
      });
  }

  // Helper method untuk handle error
  private handleOccupancyError(message: string): void {
      this.isLoadingPercentage = false;
      this.ItemsOccupancy = {} as ResedensialOccupancy;
      this.MaxLength = 0;
      this.initChartData([], 0);
      // Tambahkan error state jika perlu
      this.occupancyError = message;
  }


  loadResidenceDetailFacilities(searchTerm?: string): void {
    this.isLoading = true;
    this.error = ''; // Reset error sebelumnya
    const paramsId = this.route.snapshot.paramMap.get('id');

    this.residencesService.getResidencesDetailFacilities(
      paramsId || '',
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction ? this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC' : undefined,
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          // Memeriksa struktur respons sebelum mengassign
          this.ItemResidences = response.data;
          // console.log(this.ItemResidences)

          if (response.pagination) {
            this.paginationConfig.totalItems = response.pagination.total_items;
            this.paginationConfig.currentPage = response.pagination.current_page;
          }

          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.ItemResidences = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data residence property: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          // Error dari sisi client
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          // Error dari sisi server
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.ItemResidences = [];
      }
    });
  }

  loadResidenceDetailSummary(searchTerm?: string): void {
    this.isLoading = true;
    this.error = '';
    const paramsId = this.route.snapshot.paramMap.get('id');

    console.log('🔍 Debug - Parameter:', {
        paramsId,
        startDate: this.startDate,
        endDate: this.endDate
    });

    this.residencesService.getResidencesDetailSummary(
        paramsId || '',
        this.startDate,
        this.endDate
    ).subscribe({
        next: (response) => {
            console.log('📦 Full Response:', response);
            console.log('📊 Response type:', typeof response);
            console.log('🔑 Response keys:', Object.keys(response || {}));
            
            if (response && response.data) {
                console.log('✅ Data found in response');
                console.log('📋 Data type:', typeof response.data);
                console.log('📏 Data length:', Array.isArray(response.data) ? response.data.length : 'Not an array');
                console.log('📄 Data content:', response.data);
                
                // Cek apakah data array kosong
                if (Array.isArray(response.data) && response.data.length === 0) {
                    console.warn('⚠️ Data array is EMPTY');
                }
                
                // Cek struktur item pertama jika ada
                if (Array.isArray(response.data) && response.data.length > 0) {
                    console.log('🔎 First item structure:', response.data[0]);
                    console.log('🔎 First item keys:', Object.keys(response.data[0]));
                    
                    // Cek properti yang diperlukan
                    const requiredProps = [
                        'unit_type_name', 'curr_revenue', 'total_remark', 
                        'total_revenue_pctg', 'total_revenue', 'lm_remark',
                        'lm_revenue_pctg', 'lm_revenue', 'ly_remark',
                        'ly_revenue_pctg', 'ly_revenue', 'ty_remark', 'ty_revenue'
                    ];
                    
                    const missingProps = requiredProps.filter(prop => !(prop in response.data[0]));
                    if (missingProps.length > 0) {
                        console.warn('⚠️ Missing properties in data:', missingProps);
                    }
                }
                
                this.ItemSummaryDetail = response.data;
                this.isLoading = false;
                
                // Log setelah assignment
                console.log('📌 After assignment - ItemSummaryDetail:', this.ItemSummaryDetail);
                console.log('📌 ItemSummaryDetail length:', this.ItemSummaryDetail?.length);
                
            } else {
                console.error('❌ Response structure invalid:', response);
                console.log('Response keys available:', Object.keys(response || {}));
                this.error = 'Respons API tidak valid';
                this.isLoading = false;
                this.ItemSummaryDetail = [];
            }
        },
        error: (error) => {
            console.error('💥 HTTP Error:', error);
            console.error('Error status:', error.status);
            console.error('Error message:', error.message);
            console.error('Error object:', JSON.stringify(error, null, 2));
            
            let errorMessage = 'Error saat memuat data residence property: ';

            if (error.status === 200 && error.statusText === 'OK') {
                errorMessage += 'Error saat memproses format respons JSON';
            } else if (error.error instanceof ErrorEvent) {
                errorMessage += `Error client: ${error.error.message}`;
            } else {
                errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
            }

            console.error('❌ Final error message:', errorMessage);
            this.error = errorMessage;
            this.isLoading = false;
            this.ItemSummaryDetail = [];
        }
    });
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadResidenceDetailFacilities('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset to first page on sort
    this.updateUrlParams();
    this.loadResidenceDetailFacilities(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Hanya tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadResidenceDetailFacilities('');
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadResidenceDetailFacilities(this.searchTerm);
  }

  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  get totalRevenueOnly(): ResidencesDetailSummary[] {
      return this.ItemSummaryDetail.filter(item => item.unit_type_name === 'Total');
    }
  
  

  getPercentageClass(percentage: number): string {
      if (percentage >= 100) {
        return 'badge custom-progress-success';
      }
      return 'badge custom-progress-danger';
    }

    
}
